<template>
<div class="chapter">
<div class="inner_page">
<div class="chapterbody">
<a id="page_424"></a>
<a id="page_425"></a>
<h1 id="_RWTOC-8"><a href="#/xhtml/content#RWTOC-8">THE<br/>GILLER<br/>PRIZE</a></h1>
<a id="page_426"></a>
<a id="page_427"></a>
<p class="center" style="page-break-before:always; margin-top:25%; font-family:sans-serif"><b>The Giller Prize: Canada’s Premier Literary Prize</b></p>
<h2><i>Toronto, November 6, 2001</i></h2>
<p class="noindent">At a gala dinner and award ceremony that drew over 450 members of the publishing, media, and arts communities, Richard B. Wright was named the 2001 winner of The Giller Prize, Canada’s premier literary prize for fiction. </p>
<p>Richard B. Wright’s winning novel, <i>Clara Callan</i>, is a Phyllis Bruce Book, published by Harper<i>Flamingo</i>Canada. The largest annual prize for fiction in the country, The Giller Prize awards $25,000 each year to the author of the best Canadian novel or short story collection published in English.</p>
<p>Of the winning book, the jury remarked, “<i>Clara Callan</i> illumines, by way of a diary and letters, the inner life of an Ontario village school teacher of the 1930s, when ‘spinster’ and ‘respectable’ meant constricted emotions and a glum existence. </p>
<p>“In this atmosphere Clara enacts her private drama of doomed adulterous love and single motherhood with stoic heroism. Running parallel with and counterpointing Clara’s life is Nora’s — she is the sister who got away. </p>
<a id="page_428"></a>
<p>“An understated, graceful writer who never makes a false step, Richard B. Wright is a master at revealing the small dramas that unfold in what might appear to others as an unremarkable life. In <i>Clara Callan</i> he has achieved and accomplished an utterly convincing novel.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm2.vue?72d55193